// Test IDs del menú y el encabezado.

export const LAYOUT = {
  sidebarNavPrefix: 'sidebar-nav-', // e.g. sidebar-nav-academia
  sidebarMobileToggle: 'sidebar-mobile-toggle',
  headerUserMenuTrigger: 'header-user-menu-trigger',
  headerProfileLink: 'header-profile-link',
  headerLogoutButton: 'header-logout-button',
  headerClinicName: 'header-clinic-name',
  sidebarAcademySection: 'sidebar-academy-section',
};
